import { Container, Link, Text, Stack } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";

function SetPinError({ state }) {
  const { accountInfo, errorType } = state;
  const { cardName, cardEndsWith } = accountInfo;

  const renderContent = () => {
    switch (errorType) {
      default: {
        return (
          <Stack gap="8">
            <SvgInline name="error-dog" width="236" />
            <Text textStyle="heading5" textStyle-sm="heading4">
              Oops, something went wrong
            </Text>
            <Text>
              We've encountered an unexpected problem and are experiencing
              difficulties in processing your request. Please try again later or
              contact Latitude if the problem persists.
            </Text>
            <Link
              appearance="primary-button"
              width="216"
              href="/"
              newTab={false}
            >
              Go to overview
            </Link>
          </Stack>
        );
      }
    }
  };

  return (
    <Stack gap="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard cardName={cardName} cardEndsWith={cardEndsWith} />
      </Container>
      {renderContent()}
    </Stack>
  );
}

export { SetPinError };
